import i18n from "@euroland/libs/locale/i18n";

const TickerName = ({ shareName, marketAbbreviation }) => {
  return (
    <span className='ticker-name'>
      <span className="sr-only">{`${shareName} ${i18n.translate('marketAbbreviationFormat', marketAbbreviation)}`}</span>
      <span className="ticker-name__share-name" aria-hidden>{shareName}</span>&nbsp;
      {marketAbbreviation ? <span className="ticker-name__market-abbreviation" aria-hidden>
        {i18n.translate('marketAbbreviationFormat', marketAbbreviation)}
      </span> : null}
    </span>
  );
};

export default TickerName;
